
export default {
  // General
  save: "حفظ",
  cancel: "إلغاء",
  loading: "تحميل...",
  success: "نجاح",
  error: "خطأ",
  close: "إغلاق",
  back: "رجوع",
  next: "التالي",
  submit: "إرسال",
  done: "تم",
  noData: "لا يوجد بيانات",
  confirm: "تأكيد",
  delete: "حذف",
  edit: "تعديل",
  copy: "نسخ",
  copied: "تم النسخ",
  required: "مطلوب",
  optional: "اختياري",

  // Auth
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  confirmPassword: "تأكيد كلمة المرور",
  login: "تسجيل الدخول",
  register: "تسجيل",
  logout: "تسجيل الخروج",
  username: "اسم المستخدم",
  enterEmail: "أدخل بريدك الإلكتروني",
  enterPassword: "أدخل كلمة المرور",
  enterUsername: "أدخل اسم المستخدم",
  loginDesc: "قم بتسجيل الدخول للمتابعة",
  createAccountDesc: "قم بإنشاء حساب جديد للبدء",
  alreadyHaveAccount: "لديك حساب بالفعل؟",
  dontHaveAccount: "ليس لديك حساب؟",
  authRequired: "التحقق مطلوب",
  loginToContinue: "الرجاء تسجيل الدخول للمتابعة",
  forgotPassword: "هل نسيت كلمة المرور؟",
  resetPassword: "إعادة تعيين كلمة المرور",
  sendResetLink: "إرسال رابط إعادة التعيين",
  resetPasswordDesc: "أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة تعيين كلمة المرور",
  verifying: "جاري التحقق...",
  verificationCode: "رمز التحقق",
  enterVerificationCode: "أدخل رمز التحقق المكون من 6 أرقام",
  enterVerificationCodeDesc: "أدخل رمز التحقق المكون من 6 أرقام الذي تم إرساله إلى عنوان بريدك الإلكتروني.",
  verifyEmail: "تأكيد البريد الإلكتروني",
  verifyEmailDesc: "أدخل رمز التحقق المرسل إلى بريدك الإلكتروني",
  verificationEmailSentTo: "تم إرسال رمز التحقق إلى",
  verifyCode: "تأكيد الرمز",
  backToLogin: "العودة لتسجيل الدخول",
  resendCode: "إعادة إرسال الرمز",
  passwordStrength: "قوة كلمة المرور",
  weak: "ضعيفة",
  moderate: "متوسطة",
  strong: "قوية",
  "passwordCriteria.minLength": "٨ أحرف على الأقل",
  "passwordCriteria.uppercase": "حرف كبير واحد",
  "passwordCriteria.lowercase": "حرف صغير واحد",
  "passwordCriteria.number": "رقم واحد",
  "passwordCriteria.special": "رمز خاص واحد",
  passwordsDoNotMatch: "كلمات المرور غير متطابقة",
  passwordTooWeak: "كلمة المرور ضعيفة جداً",
  signInToAccess: "يرجى تسجيل الدخول للوصول إلى هذه المنطقة",
  accessDenied: "تم رفض الوصول",
  adminPrivilegesRequired: "يجب أن يكون لديك صلاحيات المدير",
  
  // Drafts
  loadingDrafts: "جاري تحميل المسودات...",
  noDrafts: "لا توجد مسودات",
  noDraftsFound: "لم يتم العثور على مسودات",
  draftDeleted: "تم حذف المسودة",
  draftDeletedSuccess: "تم حذف المسودة بنجاح",
  draftSaved: "تم حفظ المسودة",
  errorDeletingDraft: "خطأ في حذف المسودة",
  problemDeletingDraft: "حدثت مشكلة أثناء حذف المسودة",
  errorLoadingDrafts: "خطأ في تحميل المسودات",
  confirmDeleteDraft: "هل أنت متأكد من حذف هذه المسودة؟",
  lastEdited: "آخر تعديل",
  viewAllDrafts: "عرض جميع المسودات",
  
  // Admin specific
  adminAccess: "دخول المدير",
  adminLoginRequired: "يرجى إدخال كلمة المرور للوصول إلى لوحة تحكم المدير",
  invalidCredentials: "بيانات الاعتماد غير صحيحة",
  cannotAccessProfile: "لا يمكن الوصول إلى ملف التعريف",
  unauthorized: "غير مصرح",
  noAdminPrivileges: "ليس لديك صلاحيات المدير",
  loginSuccessful: "تم تسجيل الدخول بنجاح",
  welcomeAdminDashboard: "مرحباً بك في لوحة تحكم المدير",
  unexpectedError: "حدث خطأ غير متوقع",
  client: "عميل",
  admin: "مدير",

  // Navigation
  home: "الرئيسية",
  about: "من نحن",
  contactUs: "اتصل بنا",
  services: "الخدمات",
  blog: "المدونة",
  pricing: "التسعير",
  terms: "الشروط",
  privacy: "الخصوصية",
  faq: "الأسئلة الشائعة",
  ourPartners: "شركاؤنا",
  influencers: "المؤثرين",
  campaignCreator: "(DOOH) انشاء حملة",
  
  // Status
  404: "غير موجود",
  500: "خطأ في الخادم",
  noResults: "لا توجد نتائج",
  
  // Selection
  selectAll: "تحديد الكل",
  selectNone: "تحديد لا شيء",
  selected: "محدد",
  clear: "مسح",
  
  // Date related
  today: "اليوم",
  yesterday: "أمس",
  tomorrow: "غدًا",
  thisWeek: "هذا الأسبوع",
  lastWeek: "الأسبوع الماضي",
  nextWeek: "الأسبوع القادم",
  thisMonth: "هذا الشهر",
  lastMonth: "الشهر الماضي",
  nextMonth: "الشهر القادم",
  thisYear: "هذا العام",
  lastYear: "العام الماضي",
  nextYear: "العام القادم",

  // Common UI text
  forInquiries: "للاستفسارات",
  contactUsLink: "اتصل بنا",
} as const;
